import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useTranslation, Trans } from 'react-i18next';
import {
  FaCircleCheck,
  FaPlus,
  FaClockRotateLeft,
  FaCircleInfo,
} from 'react-icons/fa6';
import { Link, useNavigate } from 'react-router-dom';
import Header from '@components/Header/Header';
import { ListPages } from '@enums/enums';
import SideBar from '@components/SideBar/SideBar';
import Status from 'pages/DisbursementProcessed/Status';
import styles from '../DashboardReports/DashboardReports.module.scss';
import style from '../Disbursement/Disbursement.module.scss';
import styleNew from '../NewDisbursementSingle/NewDisbursementSingle.module.scss';
import styleSuccess from './DisbursementSuccess.module.scss';

const DisbursementSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const successColor = '#00bc2b';

  const email = 'test@email.com';

  const handleGoBack = () => {
    navigate(ListPages.Disbursement, { replace: true });
  };

  return (
    <div className={styles.pageContainer}>
      <Header />

      <div className={styles.mainSection}>
        <SideBar />
        <div className={styles.mainSectionWorkArea}>
          <div>
            <div className="disbursement-layout">
              <div className={styles.tableHeader}>
                <h1 className={styles.headerText}>
                  {t('disbursementSuccess.title')}
                </h1>
              </div>

              <div className={styleSuccess.disbursementSuccessWorkingArea}>
                <div className={styleSuccess.containerDataSuccess}>
                  <FaCircleCheck size={41} color={successColor} />
                  <h3 className={styleNew.subTitle}>
                    {t('disbursementSuccess.subTitle')}
                  </h3>
                </div>
                <div className={styleNew.divider} />
                <div className={styleSuccess.containerTransaction}>
                  <div className={styleSuccess.containerTransId}>
                    <span className={styleSuccess.labelTransaction}>
                      {t('disbursementSuccess.disbursementRequestNumber')}:
                    </span>
                    <span className={styleSuccess.labelTransaction}>
                      154926399094400
                    </span>
                  </div>

                  <div className={styleSuccess.containerInformation}>
                    <FaCircleInfo size={38} />
                    <span className={styleSuccess.labelTransactionDescription}>
                      <Trans
                        i18nKey="disbursementSuccess.descriptionTransId"
                        values={{ email }}
                        components={{ b: <b /> }}
                      />
                    </span>
                  </div>
                </div>
                <div className={styleSuccess.containerDataSucc}>
                  <div className={styleNew.containerCard}>
                    <label htmlFor="email" className={styleNew.labelContainer}>
                      {t('disbursement.email')}:
                    </label>
                    <InputText
                      className={styleNew.inputDescription}
                      id="email"
                      value={email}
                      readOnly
                    />
                  </div>
                  <div className="p-field">
                    <label
                      className={styleNew.labelContainer}
                      htmlFor="totalAmount"
                    >
                      {t('newDisbursement.totalAmount')}
                    </label>
                    <InputText
                      className={styleNew.inputDescription}
                      id="totalAmount"
                      value="$12345.00"
                      readOnly
                    />
                  </div>
                  <div className={styleSuccess.transactionsHistoryAdvice}>
                    <FaClockRotateLeft />{' '}
                    <p className={styleSuccess.transactionsHistoryDescription}>
                      {t('disbursementSuccess.transactionsHistoryAdvice')}
                    </p>
                    <Link
                      to={ListPages.DashboardReports}
                      className={styleSuccess.link}
                    >
                      {t('disbursementSuccess.linkTransactionHistory')}
                    </Link>
                  </div>
                </div>
                <div className={styleNew.divider} />

                <div className={style.containerButtonsDis}>
                  <Link to={ListPages.Disbursement}>
                    <Button
                      className={styleSuccess.buttonAnotherD}
                      icon={<FaPlus size={20} />}
                    >
                      {t('disbursement.buttonMakeAnother')}
                    </Button>
                  </Link>
                </div>
              </div>

              <Status />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisbursementSuccess;
